import React, { useState } from "react";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import { Button, Container, Label, Span } from "./styles";
import { FilePlus } from "react-feather";
import { ModalDivX } from "../../../ModalDivX";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";
import api from "../../../../Services/apiComunicacao";
import { Alert } from "../../../Error/Alert";
import { IComunicacao } from "../../../../Hooks/comunicacoes";
import { isRural } from "../../../../Utils/isRural";
import { useCartorio } from "../../../../Hooks/cartorio";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel_id: number;
}

export function AnexosComunicacaoModal({ open, onClose, imovel_id }: Props) {
  function handleClose() {
    onClose();
  }
  const { cartorio, cartorioIsLogged } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
    funcionarioCartorio,
  } = useFuncionarioCartorio();
  const {
    funcionarioPrefeituraIsLogged,
    FuncionarioPrefeitura,
    checarTokenFuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  const [file, setFile] = useState({} as any);
  const [fileSize, setFileSize] = useState(0);
  const [fileTeste, setFileTeste] = useState("");

  async function post() {
    try {
      setLoading(true);

      if (fileSize > 10485760) {
        setError({
          message: "O anexo não deve possuir mais que 10MB.",
          title: "Anexo muito grande!",
        });
        return false;
      }

      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }

      if (funcionarioPrefeituraIsLogged) {
        await checarTokenFuncionarioPrefeitura();
      }
      const { data } = await api.post<IComunicacao>(`/comunicacao`, {
        FUNCIONARIO_PREFEITURA_ID: funcionarioPrefeituraIsLogged
          ? FuncionarioPrefeitura.ID
          : null,
        FUNCIONARIO_CARTORIO_ID: funcionarioCartorioIsLogged
          ? funcionarioCartorio.ID
          : null,
        IMOVEL_ID: isRural() ? null : imovel_id,
        IMOVEL_RURAL_ID: isRural() ? imovel_id : null,
        MENSSAGEM: null,
        CARTORIO_ID: cartorioIsLogged ? cartorio.ID : null,
      });


      const formData = new FormData();
      formData.append("file", file);
      formData.append("COMUNICACAO_ID", `${data.ID}`);
      await api.post(`/anexo/${imovel_id}`, formData);

      setFileSize(0);
      setFileTeste("");
      onClose();
    } catch (error) {
      setError({ message: "Não foi possível enviar o anexo!", title: "Ops" });
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={() => { }} style={customStyles}>
      <ModalDivX execute={handleClose} />
      <Container>
        <Label>
          <FilePlus size={"max(2vw, 18px)"} />
          <input
            type="file"
            hidden={true}
            accept="image/*, application/pdf"
            onChange={(ev) => {
              if (ev.target.files) {
                if (ev.target.files[0].size) {
                  setFile(ev.target.files[0]);
                  setFileSize(ev.target.files[0].size);
                } else {
                  setFileSize(0);
                }
              }

              setFileTeste(ev.target.value);
            }}
          />
        </Label>
        <Span>{fileTeste}</Span>
        <Button onClick={post}>ENVIAR</Button>

        <Alert
          message={error.message}
          title={error.title}
          open={error.message.length > 0}
          onClose={() => setError({ message: "", title: "" })}
        />
      </Container>
    </Modal>
  );
}
